import React from "react";
import "./function.css";
import Function1 from "./function1";
import Function2 from "./function2";
import Function3 from "./function3";
import Function4 from "./function4";
import Function5 from "./function5";
import Function6 from "./function6";
import Function7 from "./function7";
import Function8 from "./function8";
import Function9 from "./function9";
import Function10 from "./function10";
import Function11 from "./function11";
import Function12 from "./function12";
import Function13 from "./function13";
import Function14 from "./function14";
import Function15 from "./function15";
import Function16 from "./function16";

const COMPONENTS = {
  1: Function1, 2: Function2, 3: Function3, 4: Function4, 5: Function5,
  6: Function6, 7: Function7, 8: Function8, 9: Function9, 10: Function10,
  11: Function11, 12: Function12, 13: Function13, 14: Function14, 15: Function15,
  16: Function16,
};

export default function Function({ functionType, mobileTypeId, data, status, setStatus, machineInfo }) {
  const machineID = data.field_mobile_id;
  const Component = COMPONENTS[functionType];
  if (!Component) {
    return (
      <React.Fragment>
        <td>Not Yet</td>
        <td>Not Yet</td>
      </React.Fragment>
    );
  }
  return (
    <Component
      machineID={machineID}
      data={data}
      status={status}
      setStatus={setStatus}
      machineInfo={machineInfo}
    />
  );
}